/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Select, SelectItem } from 'carbon-components-react';

export default class SelectField extends Component {
    getOption(option, other) {
        const selected = other.value === option;

        return <SelectItem
            key={option}
            value={option}
            text={option}
            disabled={other.disabled || (other.readOnly && !selected)}
        />;
    }

    render() {
        const {
                label,
                description,
                placeholder,
                options,
                errors,
                showIf,
                ...other
            } = this.props,
            helperText = description && description() ? description() : false;

        return (
            <div className='ht-field select'>
                <Select
                    labelText={label}
                    helperText={helperText}
                    text={placeholder}
                    invalid={!!errors}
                    invalidText={errors}
                    readOnly={other.readOnly}
                    {...other}
                >
                    <SelectItem disabled value='' text={placeholder} />
                    {options && options().map(option => this.getOption(option, other))}
                </Select>
            </div>
        );
    }
}
